import { render, staticRenderFns } from "./DeliveryFiles.vue?vue&type=template&id=4483195c&scoped=true&"
import script from "./DeliveryFiles.vue?vue&type=script&lang=js&"
export * from "./DeliveryFiles.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFiles.vue?vue&type=style&index=0&id=4483195c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4483195c",
  null
  
)

export default component.exports